import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import TabNavigation from '../components/TabNavigation.jsx';
import ShippingAddress from '../components/Configuration/ShippingAddress.jsx';
import ImportConfigurations from '../components/Configuration/ImportConfigurations.jsx';

const CONFIG_TABS = [
    { label: 'Shipping Address', value: 0 },
    { label: 'Supplier Presets', value: 1 },
];

export default function Configuration() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setSearchParams({ t: newValue });
    };

    useEffect(() => {
        const tabFromUrl = parseInt(searchParams.get('t'));
        if (!isNaN(tabFromUrl) && tabFromUrl !== value) {
            setValue(tabFromUrl);
        } else if (isNaN(tabFromUrl) && value !== 0) {
            setValue(0);
            setSearchParams({ t: 0 });
        }
    }, [searchParams]);

    const tabPage = (index) => {
        switch (index) {
            case 0:
                return <ShippingAddress />;
            case 1:
                return <ImportConfigurations />;
            default:
                return <ShippingAddress />;
        }
    };

    return (
        <div className="card border-0" style={{
            height: 'calc(100vh - 56px)',
            display: 'flex',
            flexDirection: 'column',
        }}>
            <div
                className="card-header bg-white"
                style={{
                    padding: '0 20px 5px 20px',
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                    borderBottom: '1px solid #eee',
                }}
            >
                <h2 style={{ margin: 0, paddingTop: '10px' }}>Configuration</h2>
                <p style={{ margin: 0 }}>Ship-from address and invoice supplier presets</p>
            </div>
            <div className="card-body" style={{ flex: 1, overflowY: 'auto', margin: 0, padding: '0 20px' }}>
                <TabNavigation
                    value={value}
                    onChange={handleChange}
                    tabs={CONFIG_TABS}
                />
                {tabPage(value)}
            </div>
        </div>
    );
}
